<template>
	<div id="app">
		<div style="min-height: 100vh;" v-loading="!isReady" element-loading-text="请稍后...">
			<!-- <router-view v-if="isReady"/> -->
			<!-- 用 keep-alive 缓存需要保留状态的页面 -->
			<keep-alive>
				<!-- 只缓存 meta.keepAlive 为 true 的路由页面 -->
				<router-view v-if="isReady && $route.meta.keepAlive" />
			</keep-alive>
			
			<!-- 不缓存的页面直接渲染 -->
			<router-view v-if="isReady && !$route.meta.keepAlive" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'app',
	data(){
		return{
			
		}
	},
	created() {
		if(this.token) this.getUser()
		this.getData()
	},
	methods: {
		async getData(){
			this.$http.get('/api/webs/search/sys', { isAuth: false })
			    .then(response => {
			        let res = response.data
					
					this.$nextTick(() => this.isReady = true)
					
					if(res == null) return
					let swpier = JSON.parse(res.sysImg).map(v => {
						return { image: process.env.VUE_APP_BASE_API + v }
					})
					this.setSwiper(swpier)
					res.kfImg = JSON.parse(res.kfImg).map(v => process.env.VUE_APP_BASE_API + v)
					res.sysLogo = JSON.parse(res.sysLogo).map(v => process.env.VUE_APP_BASE_API + v)
					this.setSysInfo(res)
			    })
			    .catch(error => {
			        console.error(error)
			    })
		}
	}
}
</script>

<style>
#app {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000000;
}
@import "./assets/css/base.css";
.el-loading-mask{
	z-index: 1999 !important;
}
.el-message{
	z-index: 99999 !important;
}
</style>
